/** @format */

import type { ContentEditorPart } from 'src/types';

function hasMedia(value: { url?: string } | null | undefined, file?: File | null, removed?: boolean): boolean {
  if (removed) return false;
  if (file instanceof File) return true;
  return Boolean(value && value.url);
}

export function isContentEditorPartFilled(part: ContentEditorPart | null | undefined): boolean {
  if (!part) return false;

  switch (part.type) {
    case 'content':
      return Boolean(part.text && part.text.trim());
    case 'documents':
      return (
        Array.isArray(part.documents) &&
        part.documents.some(
          document =>
            !document?._remove &&
            Boolean(
              (document.file && document.file instanceof File) ||
                document.id ||
                document.url ||
                document.remoteUrl
            )
        )
      );
    case 'image':
      return hasMedia(part.image, part._file, part._imageRemove);
    case 'imageText':
      return Boolean(part.title && part.title.trim()) && Boolean(part.text && part.text.trim());
    case 'video':
      return hasMedia(part.video, part._file, part._videoRemove);
    case 'salesInformationNo':
      return Boolean(part.salesInformationNo && part.salesInformationNo.trim());
    case 'serviceInformationNo':
      return Boolean(part.siNumber && part.siNumber.trim());
    case 'casaNumber':
      return (
        (Array.isArray(part.casaPartNumbers) && part.casaPartNumbers.length > 0) ||
        (Array.isArray(part.casaHierarchies) && part.casaHierarchies.length > 0)
      );
    default:
      return false;
  }
}
